__turbopack_context__.v({
  "Content": "index-module-scss-module__iFTEka__Content",
  "Details": "index-module-scss-module__iFTEka__Details",
  "IconSlot": "index-module-scss-module__iFTEka__IconSlot",
  "Summary": "index-module-scss-module__iFTEka__Summary",
  "arrow-icon": "index-module-scss-module__iFTEka__arrow-icon",
});
